import { FormattedMessage } from 'react-intl';
import { JSX } from 'react';

import { useStyles } from './top-section.styles';
import { ContentWrapper } from '../../../common/content-wrapper';
import { Button } from '../../../common/button';
import { Logos } from '../../../common/logos';
import { SectionLabels } from '../../../../constants/common-constants';

export const TopSection = (): JSX.Element => {
  const classes = useStyles();
  const id = SectionLabels.top;

  return (
    <section
      className={classes.root}
      data-testid="about"
      aria-labelledby={id}
    >
      <ContentWrapper externalStyles={classes.contentStyles}>
        <Logos />
        <h1 className={classes.title} id={id}>
          <span className={classes.titleFirst}><FormattedMessage id="top.title-1" /></span>
          <span className={classes.titleSecond}><FormattedMessage id="top.title-2" /></span>
        </h1>
        <Button
          variant="dark"
          to="#join-section"
          ariaLabel="top.button.ariaLabel"
        >
          <FormattedMessage id="top.button" />
        </Button>
        <p className={classes.content}>
          <FormattedMessage id="top.content" />
        </p>
      </ContentWrapper>
    </section>
  );
};
